module.exports = __webpack_public_path__ + "static/b4c87319.third-group-img.png";